<template>
	<el-dialog title="编辑MIF" center :visible.sync="dialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="500px">
		<el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
			<!--<el-form-item label="分支" prop="branchInfo">-->
			<!--	<el-input v-model="form.branchInfo" placeholder="请输入分支"></el-input>-->
			<!--</el-form-item>-->
			<!--<el-form-item label="CL编码" prop="clCode">-->
			<!--	<el-input v-model="form.clCode" placeholder="请输入CL编码"></el-input>-->
			<!--</el-form-item>-->
			<!--<el-form-item label="项目" prop="itemName">-->
			<!--	<el-input v-model="form.itemName" placeholder="请输入项目"></el-input>-->
			<!--</el-form-item>-->
			<!--<el-form-item label="课程名称" prop="courseName">-->
			<!--	<el-input v-model="form.courseName" placeholder="请输入课程名称"></el-input>-->
			<!--</el-form-item>-->
			<el-form-item label="MIF类型" prop="mifType">
				<div class="item1">
					<el-select v-model="form.mifType" placeholder="请选择MIF类型" disabled>
						<el-option v-for="item in codes" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
			</el-form-item>
			<el-form-item label="MIF值" prop="mifType">
				<div class="item1">
					<el-input v-model="form.mifVal"></el-input>
				</div>
			</el-form-item>
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { debounce } from "@/utils/debounce";
import { courseSkillMifUpdate, listByCodesPerm } from "@/api/skill";
export default {
	data() {
		return {
			dialogVisible: false,
			submitLoading: false,
			codes: [],
			form: {
				id: "",
				// branchInfo: "",
				// clCode: "",
				// itemName: "",
				// courseName: "",
				mifType: "",
				mifVal: "",
			},
			rules: {
				// branchInfo: [{ required: true, message: "请输入分支", trigger: "blur" }],
				// clCode: [{ required: true, message: "请输入CL编码", trigger: "blur" }],
				// itemName: [{ required: true, message: "请输入项目", trigger: "blur" }],
				// courseName: [{ required: true, message: "请输入课程名称", trigger: "blur" }],
				mifType: [{ required: true, message: "请选择MIF类型", trigger: "change" }],
				mifVal: [{ required: true, message: "请输入MIF值", trigger: "blur" }],
			},
		};
	},
	methods: {
		// 初始化弹窗
		init(dt) {
			this.dialogVisible = true;
			this.submitLoading = false;
			this.form = {
				id: dt.id,
				// branchInfo: dt.branchInfo || "",
				// clCode: dt.clCode || "",
				// itemName: dt.itemName || "",
				// courseName: dt.courseName || "",
				mifType: dt.mifType || "",
				mifVal: dt.mifVal || "",
			};
			// 获取mif列表
			this.getByCodes();
		},
		// 获取mif列表
		getByCodes() {
			listByCodesPerm({ codes: "mifType" }).then((res) => {
				this.codes = res.data.mifType || [];
			});
		},
		// 关闭弹窗
		handleClose() {
			this.dialogVisible = false;
			this.submitLoading = true;
		},
		// 提交表单
		handleSubmit: debounce(function () {
			this.$refs.form.validate((valid) => {
				if (!valid) return;
				if (this.submitLoading) return;
				this.handleClose();
				courseSkillMifUpdate(this.form).then((res) => {
					this.submitLoading = false;
					if (res.code != "0") return this.$message.error(res.msg);
					this.$message.success("保存成功");

					this.$emit("refresh");
				});
			});
		}, 300),
	},
};
</script>

<style lang="scss" scoped>
.item1 {
	display: flex;
	.el-select {
		width: 200px;
		margin-right: 10px;
	}
	.el-input {
		width: 200px;
	}
}
</style>
